import Cookies from 'js-cookie';
import { FREE_SHIPPING_THRESHOLD_CURRENCY } from '../../constants';
import { SESSION_KEY_PREFIX } from '../../constants';

import type { Currency } from '../../constants';
import { Cookie } from '../../model';

/**
 * Function to set the cart session key
 * Saves the session key to both cookies and closure-based storage
 */
export const setCartSessionKey = ({ name, value }: Required<Cookie>) => {
  const newSessionKey = `${name}=${value}`;
  Cookies.set(name, value, {
    expires: 30,
  });
  return newSessionKey;
};

/**
 * Function to get the cart session key from cookies
 * Returns the cart session key cookie if found
 */
export const getCartSessionKey = () => {
  const allCookies = Cookies.get();
  const cartSessionKeyName = Object.keys(allCookies).find((cookieName) => cookieName.includes(SESSION_KEY_PREFIX));

  if (cartSessionKeyName) {
    const cartSessionKey: Cookie = {
      name: cartSessionKeyName,
      value: allCookies[cartSessionKeyName],
    };
    return { cartSessionKey };
  }

  return { cartSessionKey: undefined };
};
